module.exports = __webpack_public_path__ + "static/media/g1.771170bd.jpg";